import { MutationTree } from 'vuex'
import { Catalog } from '@one/types'
import { BrandsState } from './types'

export const mt = {
  SET_BRANDS_TREE: 'SET_BRANDS_TREE',
  SET_HIGHLIGHTED_BRANDS_TREE: 'SET_HIGHLIGHTED_BRANDS_TREE',
  SELECT_BRAND: 'SELECT_BRAND',
  CLEAR_SELECTED_BRAND: 'CLEAR_SELECTED_BRAND',
}

export const mutations: MutationTree<BrandsState> = {
  [mt.SET_BRANDS_TREE](
    state: BrandsState,
    tree: Catalog.BrandAndSeriesTreeItem[],
  ) {
    state.brandsTree = tree
  },
  [mt.SET_HIGHLIGHTED_BRANDS_TREE](
    state: BrandsState,
    tree: Catalog.BrandAndSeriesTreeItem[],
  ) {
    state.highlightedBrandsTree = tree
  },
  [mt.SELECT_BRAND](
    state: BrandsState,
    brand: Catalog.BrandAndSeriesTreeItem | null,
  ) {
    state.selectedBrand = brand
  },
  [mt.CLEAR_SELECTED_BRAND](state: BrandsState) {
    state.selectedBrand = null
  },
}

export default mutations
